import { render } from "./OrderStudents.vue?vue&type=template&id=06b7502c&ts=true"
import script from "./OrderStudents.vue?vue&type=script&lang=ts"
export * from "./OrderStudents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__